import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
export const DraftCreatedActivity = (): ReactElement => {
  const { t } = useTranslator();
  return <span>{t('activity_description_DraftCreated')}.</span>;
};
